import React, { useEffect, useState } from "react";
import { genericFetchData } from "../../../Services/Service";
import { getUserRole } from "../../../Storage/Datastore";
import { checkPermission, getUserRoles } from "../../../Utils/Permissions";

export default function useHospital() {
  const [page, setPage] = useState(1);
  const [hospitals, setHospitals] = useState("");
  const [locations, setLocations] = useState({});
  const [insurance, setInsurance] = useState({});
  const [departments, setDepartments] = useState({});
  const [hospitalData, setHospitalData] = useState([]);
  const [platform, setPlatform] = useState([]);
  const [flaggedItems, setflaggedItems] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [modal, setModal] = useState({ isOpen: false });
  const [filter, setFilter] = useState({
    departmentId: 0,
    insuranceId: 0,
    platformId: 0,
    keyword: "",
    locationId: 0,
    approved: "",
  });

  const getHospitalFilterData = async () => {
    const postFilterData = {
      ...filter,
      pageNo: page,
      pageSize: 10,
    };
    const response = await genericFetchData(
      `/center/filtered`,
      "POST",
      postFilterData
    );
    const responseData = await response.json();
    console.log("responseData*****" + JSON.stringify(responseData));
    if (responseData) {
      const mappedData = responseData?.centers?.map((val) => {
        return {
          id: val?.id,
          cellItem1: val?.name,
          cellItem2: val?.location,
          cellItem3: val?.approved,
          cellItem4: val?.status,
        };
      });
      let res = { count: responseData?.count, centers: mappedData };
      setHospitalData(res);
    }
  };
  const getAllDepartments = async () => {
    const response = await genericFetchData(`/departments/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setDepartments(responseData.departments);
    } else {
      console.log("=======error");
    }
  };
  const getAllLocations = async () => {
    const response = await genericFetchData(`/locations/basic/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setLocations(responseData.locations);
    } else {
      console.log("=======error");
    }
  };

  const getAllPlatform = async () => {
    const response = await genericFetchData(`/data/platform/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setPlatform(responseData.platforms);
      console.log(responseData.platforms, "+++h");
    } else {
      console.log("=======error");
    }
  };

  const getAllInsurance = async () => {
    const response = await genericFetchData(`/insurance/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      const insuranceData = responseData.insurances?.map((val) => {
        return { id: val.insuranceId, name: val.insuranceName };
      });
      setInsurance(insuranceData);
    } else {
      console.log("=======error");
    }
  };

  useEffect(() => {
    getHospitalFilterData();
    getAllDepartments();
    getAllLocations();
    getAllInsurance();
    getAllPlatform();
  }, [page, filter]);

  // const handleSelectedLocation = (e, value) => {
  //   setLocationId(value?.id);
  //   getHospitalFilterData(value?.id, departmentsId, onchangeValue, insuranceId);
  // };

  // const handleSelectedDepartment = (e, value) => {
  //   setDepartmentsId(value?.id);
  //   getHospitalFilterData(locationId, value?.id, onchangeValue, insuranceId);
  // };

  // const onChagevalue = (e) => {
  //   setOnchangeValue(e.target.value);
  //   getHospitalFilterData(
  //     locationId,
  //     departmentsId,
  //     e.target.value,
  //     insuranceId
  //   );
  // };

  const handleCheckboxChange = (checked, index) => {
    let approvedData = {};
    const userRole = getUserRole();
    if (checkPermission("DB_LEADS_APROVAL")) {
      const approv = getUserRoles(userRole);
      approvedData = {
        departmentApproved: { [approv]: checked },
        hospitalId: index,
      };
      saveHospitalUpdate(approvedData);
    } else {
      approvedData = { approved: checked, hospitalId: index };
      saveHospitalStatus(approvedData);
    }
    const approvedItem = hospitalData?.centers?.map((item) =>
      item.id === index ? { ...item, cellItem3: checked } : item
    );
    setCheckedItems(approvedItem);
  };

  const handleApprovePopup = (event, index) => {
    approveData.checked = event.target.checked;
    approveData.index = index;
    setModal({ isOpen: true, data: approveData });
  };

  const approveData = {
    headText: "",
    source: "Are you sure want to Approve?",
    type: "APPROVE",
    handleApprove: handleCheckboxChange,
    width: "400px",
    height: "200px",
    buttons: [
      { id: 1, buttonName: "No" },
      { id: 2, buttonName: "Yes" },
    ],
  };
  const handleStausChange = (checked, index, reason) => {
    const approvedData = {
      status: checked ? "FLAGGED" : "GOOD",
      hospitalId: index,
      reason: reason,
    };
    const approvedItem = hospitalData?.centers?.map((item) =>
      item.id === index ? { ...item, cellItem4: checked } : item
    );
    setflaggedItems(approvedItem);
    saveHospitalStatus(approvedData);
  };

  const handleStatusPopup = (event, index) => {
    statusData.checked = event.target.checked;
    statusData.index = index;
    setModal({ isOpen: true, data: statusData });
  };

  const statusData = {
    headText: "Add Flagged Reason",
    source: "Are you sure want to Approve?",
    type: "FLAG",
    handleApprove: handleStausChange,
    width: "400px",
    height: "200px",
    buttons: [
      { id: 1, buttonName: "Cancel" },
      { id: 2, buttonName: "Add" },
    ],
  };

  const deleteTableCell = (cellId) => {
    const postData = {
      active: false,
      hospitalId: cellId,
    };
    saveHospitalStatus(postData);
  };

  const handleDelete = (cellId) => {
    deleteBoxData.deleteId = cellId;
    setModal({ isOpen: true, data: deleteBoxData });
  };

  const deleteBoxData = {
    headText: "",
    source: "Are you sure want to delete?",
    type: "DELETE",
    deleteData: deleteTableCell,
    width: "400px",
    height: "200px",
    buttons: [
      { id: 1, buttonName: "No" },
      { id: 2, buttonName: "Yes" },
    ],
  };

  const saveHospitalStatus = async (postData) => {
    const response = await genericFetchData(
      `/center/status/save`,
      "POST",
      postData
    );
    const status = response.status;
    if (status === 200) {
      getHospitalFilterData();
    } else if (status === 400) {
      const responseData = await response.json();
      const errorMessage = responseData.errorMessage;
      alert(errorMessage);
    }
  };
  const saveHospitalUpdate = async (postData) => {
    const response = await genericFetchData(
      `/center/status/update`,
      "POST",
      postData
    );
    const status = response.status;
    if (status === 200) {
      getHospitalFilterData();
    } else if (status === 400) {
      const responseData = await response.json();
      const errorMessage = responseData.errorMessage;
      alert(errorMessage);
    }
  };

  useEffect(() => {
    setHospitals(hospitalData.centers);
  }, [hospitalData]);
  return {
    hospitalData,
    hospitals,
    page,
    setPage,
    handleApprovePopup,
    handleStatusPopup,
    modal,
    setModal,
    checkedItems,
    setCheckedItems,
    flaggedItems,
    handleDelete,
    departments,
    locations,
    setLocations,
    insurance,
    setFilter,
    platform,
  };
}
